<template>
  <view class="dialog-confirm-passenger-demo">
    <cube-button  bind:click="onClickDialog">Dialog - confirm</cube-button>
    <cube-dialog

      wx:ref="dialogConfirm"
      class="custom-dialog-confirm"
      type="confirm"
      title="我是标题要精简"
      content="正文行文符合话术规范，表意清晰可多行展示，单行居中对齐，多行居左"
      confirm-btn="引导文案"
      cancel-btn="按钮文案"
    ></cube-dialog>
  </view>
</template>

<script>
import { createComponent } from '@mpxjs/core'

createComponent({
  options: {
    styleIsolation: 'shared'
  },
  methods: {
    onClickDialog () {
      const dialogRef = this.$refs.dialogConfirm
      dialogRef.show()
    }
  }
})
</script>

<style lang="stylus">
.custom-dialog-confirm .cube-dialog-confirm .cube-dialog-btns .cube-dialog-btn:first-child
  color #444
</style>

<script type="application/json">
  {
    "styleIsolation": "shared",
    "component": true,
    "usingComponents": {
      "cube-button": "@mpxjs/mpx-cube-ui/src/components/button/index",
      "cube-dialog": "@mpxjs/mpx-cube-ui/src/components/dialog/index"
    }
  }
</script>
